export const MAX_BONUS_SPEND_RATE = 0.3;
export const BONUS_ACCRUAL_RATE = 0.15;

export const roundRub = (n) => Math.round((Number(n) || 0) * 100) / 100;

export function calcMaxBonusSpend(rentTotal, balance) {
  const cap = roundRub((Number(rentTotal) || 0) * MAX_BONUS_SPEND_RATE);
  return roundRub(Math.min(Math.max(0, Number(balance) || 0), cap));
}

export const bonusTypeLabels = {
  accrual: 'Начисление',
  spend: 'Списание',
  refund: 'Возврат',
  adjust: 'Корректировка',
};
